import { queryClient as apiQueryClient } from '@frontend/api';

export const invalidateAllBOMRestructureQueries = () => {
  apiQueryClient.invalidateQueries({ queryKey: ['bomRestructureInfo'] });
};

export const invalidateAllAssemblyTreeQueries = () => {
  apiQueryClient.invalidateQueries({ queryKey: ['quoteItemAssemblyTree'] });
  invalidateAllBOMRestructureQueries();
};
